import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { RadioGroup } from '@anyui/core';
import { ProposalJobDescriptionBreakDownMode } from '@anytag/graphql';
import { Button, Radio, SplitButton } from '@anytag/shared-atoms';
import { TableModeType } from '../../schema-types';
import { useEngagementProposalSearch } from '../hooks';
import { EngagementProposalInfluencersFormValues } from '../types';

export interface TableModesProps {
  jdMode: ProposalJobDescriptionBreakDownMode;
  onShowConfirmModal: () => void;
  onEditJdMode: (mode: ProposalJobDescriptionBreakDownMode) => void;
}

export const TableModes = ({ jdMode, onEditJdMode, onShowConfirmModal }: TableModesProps) => {
  const { t } = useTranslation();
  const {
    formState: { isSubmitting, isDirty }
  } = useFormContext<EngagementProposalInfluencersFormValues>();
  const { isEditMode, setFilter } = useEngagementProposalSearch();

  return (
    <div className="box-border flex h-12 items-center justify-between rounded-t-sm bg-white px-4 py-2">
      <SplitButton
        options={[
          {
            title: t('View'),
            variant: 'outline',
            prefixIcon: { icon: 'hamburger-menu', size: 11 },
            onClick: () => {
              if (isDirty) {
                onShowConfirmModal();
              } else {
                setFilter({ tableViewMode: TableModeType.VIEW });
              }
            },
            isActive: !isEditMode
          },
          {
            title: t('Budget Edit'),
            variant: 'outline',
            prefixIcon: { icon: 'eraser', size: 11 },
            onClick: () => setFilter({ tableViewMode: TableModeType.EDIT }),
            isActive: isEditMode
          }
        ]}
      />

      <div className="flex items-center">
        <p className="mr-2 text-sm leading-4.5">{t('SetBudgetBy')}:</p>
        <RadioGroup value={jdMode} onChange={(value) => onEditJdMode(value as ProposalJobDescriptionBreakDownMode)}>
          <Radio value={ProposalJobDescriptionBreakDownMode.SOCIAL_BREAKDOWN} label={t('Social Media')} />
          <Radio value={ProposalJobDescriptionBreakDownMode.INFLUENCER_BREAKDOWN} label={t('General.Influencer')} />
        </RadioGroup>
        <Button
          variant="solid"
          type="submit"
          className="ml-4 px-4"
          title={t('Button.Save')}
          disabled={!isDirty}
          loading={{ status: isSubmitting, title: t('Button.Saving') }}
        />
      </div>
    </div>
  );
};
